/*
 * @Author       : 程哲林
 * @Date         : 2023-05-09 19:44:20
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-09-14 13:46:46
 * @FilePath     : /marketing-introduce-ssr/components/Activity/Guidance/index.tsx
 * @Description  : 未添加文件描述
 */
import React, { useEffect, useMemo, useRef, useState } from 'react';

import { isBrowser } from '@/common/const';
import { isWXBrowser, qsParse } from '@/utils';
import bus from '@/utils/bus';
import { sensElementView } from '@/utils/sensors';

import styles from './index.module.scss';

export interface NoviceGuidance {
  componentId?: any;
  componentType: string;
  sortNum?: any;
  data: NoviceGuidanceData;
  componentName: string;
}

interface NoviceGuidanceData {
  showType: string;
  newbieGuideFile: string;
  showWidth: number;
  fileCover: string;
}

export const NEWBIE_EVENT_NAME = 'newbie-guide';

const { channel = '', channelNo = '' } = qsParse();

const iswx = isWXBrowser();

const Guidance = React.memo(
  ({ visible, data }: Pick<NoviceGuidance, 'data'> & { visible: boolean }): JSX.Element | null => {
    const [visibility, setVisibility] = useState(visible);
    const videoRef = useRef<HTMLVideoElement>(null);

    const isAndroid = useMemo(() => {
      if (isBrowser) {
        const { userAgent } = navigator;
        return userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
      }
      return false;
    }, []);

    useEffect(() => {
      const currentVideoRef = videoRef.current;
      return () => {
        if (currentVideoRef) {
          currentVideoRef.pause();
        }
      };
    }, [videoRef]);

    useEffect(() => {
      const event = () => {
        setVisibility(true);
      };

      bus.on(NEWBIE_EVENT_NAME, event);

      return () => {
        bus.off(NEWBIE_EVENT_NAME, event);
      };
    }, []);

    useEffect(() => {
      if (visibility) {
        if (window.wx) {
          wx.ready(() => {
            videoRef.current?.play();
          });
        }

        sensElementView({
          c_element_name: '运营活动活动页_组件浏览',
          material_type: '新手引导',
          channel,
          channelNo,
          activity_id: __store.actInfo.id,
          activity_label: __store.actInfo.activityType,
          material_ids: [__store.actInfo.webPageId || '']
        });
      }
    }, [visibility]);

    if (!visibility || !data) {
      return null;
    }

    const { newbieGuideFile, showWidth, fileCover } = data;

    const isVideo = /\.(mp4|flv)/gim.test(newbieGuideFile);

    return (
      <div className={styles['cp-guid']}>
        <div className={styles.box}>
          <div
            style={{
              width: `${(showWidth || 300) / 50}rem`
            }}
            className={styles.img}>
            {isVideo ? (
              <video
                ref={videoRef}
                controls
                muted={!(iswx && isAndroid)}
                autoPlay
                loop
                webkit-playsinline='true'
                playsInline={true}
                src={newbieGuideFile}
                poster={fileCover}
              />
            ) : (
              <img src={newbieGuideFile} alt='' />
            )}
          </div>
          <button
            onClick={() => {
              setVisibility(false);
            }}
            type='button'
            className={styles.btn}>
            关闭
          </button>
        </div>
      </div>
    );
  }
);

export default Guidance;
